import React, { type FunctionComponent, } from "react";



export const Users: FunctionComponent = () => (
	<svg viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1642_5508)">
			<path d="M24.1805 30.1252V27.3197C24.1805 25.8315 23.5893 24.4043 22.537 23.352C21.4847 22.2997 20.0575 21.7085 18.5693 21.7085H7.34701C5.85883 21.7085 4.43161 22.2997 3.37931 23.352C2.32701 24.4043 1.73584 25.8315 1.73584 27.3197V30.1252" stroke="#D3D3D3" strokeWidth="2.80558" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12.9581 16.0973C16.0571 16.0973 18.5693 13.5851 18.5693 10.4862C18.5693 7.3872 16.0571 4.875 12.9581 4.875C9.85913 4.875 7.34692 7.3872 7.34692 10.4862C7.34692 13.5851 9.85913 16.0973 12.9581 16.0973Z" stroke="#D3D3D3" strokeWidth="2.80558" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M32.5972 30.125V27.3194C32.5963 26.0762 32.1825 24.8684 31.4208 23.8858C30.6591 22.9032 29.5926 22.2014 28.3889 21.8906" stroke="#D3D3D3" strokeWidth="2.80558" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M22.7776 5.05713C23.9846 5.36617 25.0544 6.06812 25.8184 7.05233C26.5824 8.03654 26.997 9.24703 26.997 10.4929C26.997 11.7389 26.5824 12.9493 25.8184 13.9336C25.0544 14.9178 23.9846 15.6197 22.7776 15.9288" stroke="#D3D3D3" strokeWidth="2.80558" strokeLinecap="round" strokeLinejoin="round" />
		</g>
		<defs>
			<clipPath id="clip0_1642_5508">
				<rect width="33.667" height="33.667" fill="white" transform="translate(0.333008 0.666504)" />
			</clipPath>
		</defs>
	</svg>
);
